
class TimeZoneService {

    /**
     * Returns the auction time zone defined in the tenant config
     *
     * @returns {string|*}
     */
    auctionTimeZone() {
        let loc =  window.page?.props?.global?.localization;
        let zones = loc?.availableTimeZones;
        let timeZone = Object.keys(zones).find((zone) => {
            return zone === loc?.auctionTimeZoneCode;
        });
        if(timeZone && zones) {
            return zones[timeZone];
        }
        return 'America/New_York'; // ONLY as a fallback
    }

    /**
     * Returns the auction time zone code from the current settings which is only used to render it where required
     *
     * @returns {*|string}
     */
    code() {
        return window.page?.props?.global?.localization?.auctionTimeZoneCode || 'ET'; // 'ET' is a fallback
    }
}

export default new TimeZoneService();
